"use client";
import React from "react";

interface ConsentFormParaIConsentProps {
  fontSize?: number | string;
  lineHeight?: number | string;
}

const ConsentFormParaIConsent = ({
  fontSize = 15,
  lineHeight = "1.4rem",
}: ConsentFormParaIConsentProps) => {
  return (
    <span
      style={{
        fontFamily: "var(--font-raleway, Raleway)",
        fontWeight: "lighter",
        fontSize,
        color: "var(--color-text, #65758B)",
        lineHeight,
        alignSelf: "center",
      }}
    >
      I consent to be contacted by Amity University Online via Email, SMS,
      WhatsApp, or Call, overriding any DNC/NDNC registration.
    </span>
  );
};

export default ConsentFormParaIConsent;
